<div class="table-loader">
  <ed-loader
    [edLoaderConfig]="{
          dotSize: 16,
          ellipsisBackgroundColor: 'gray',
        }"
  ></ed-loader>
</div>
